<template>
  <b-container>
    <b-form-group :disabled="changes_disabled">
      <b-form-group>
        <label>
          <b> {{ $t('table_chosen') }} </b>
        </label>
        <b-form-select v-model="table" :options="table_options" />
      </b-form-group>

      <b-card>
        <columns-choice-options
          v-model="unicity_cols"
          :main_text="$t('primary_key_selection')"
          :available_column_names="columns"
        >
          <template #sub_component="props">
            <generic-column-name-edition
              v-bind="props"
              v-on="props.listeners"
            />
          </template>
        </columns-choice-options>
      </b-card>

      <b-card class="mt-3">
        <!-- We may want to use something like columns choice options select
        but with a slot that lets us choose what is right to the selection
        (in unique, choose operation, here choose new name, etc...) -->
        <columns-choice-options
          v-model="discriminating_cols"
          :main_text="$t('duplicate_values_to_keep')"
          :available_column_names="columns"
          :entry_constructor="generic_column_name_for_unicity_constructor"
        >
          <template #sub_component="props">
            <generic-column-name-edition-for-unicity
              v-bind="props"
              v-on="props.listeners"
            />
          </template>
        </columns-choice-options>
      </b-card>
    </b-form-group>
  </b-container>
</template>

<i18n>
{
  "en": {
    "primary_key_selection": "Select columns that define a primary key",
    "duplicate_values_to_keep": "Select values of the line to keep in case of duplicates",
    "wanted_operation": "Wanted operation"
  },
  "fr": {
    "primary_key_selection": "Sélectionnez les colonnes définissant une clé primaire",
    "duplicate_values_to_keep": "Sélectionnez les valeurs de la ligne à conserver en cas de doublons",
    "wanted_operation": "Opération souhaitée"
  }
}

</i18n>

<script>
import _ from 'lodash'

import { table_columns } from '@/api/subscriptions.js'

// import {
//   subscription_mixin,
//   brick_mixin,
//   brick_with_single_parent_mixin,
// } from '@/components/mixin.js'
import { global_brick_mixin } from '@/components/mixin.js'
import ColumnsChoiceOptions from './columns_choice_options.vue'
import { GenericColumnNameForUnicity } from '@/components/object_model.js'
import GenericColumnNameEdition from '@/components/generic_column_name_edition.vue'
import GenericColumnNameEditionForUnicity from '@/components/generic_column_name_edition_for_unicity.vue'
import CoercionDateFormats from './coercion_date_formats.vue'

import { BasicTableInfoEntity } from '@/components/object_model.js'

// *****************************************************************************

export default {
  name: 'BrickUnique',
  components: {
    ColumnsChoiceOptions,
    GenericColumnNameEdition,
    GenericColumnNameEditionForUnicity,
  },
  // mixins: [subscription_mixin, brick_mixin, brick_with_single_parent_mixin],
  mixins: [global_brick_mixin],
  // props: [
  //   'brick_id',
  //   'project_id',
  //   'description_name',
  //   'metavariables_dicts_poids',
  // ],
  data() {
    return {
      table: -1,
      columns: [],
      unicity_cols: [],
      discriminating_cols: [],
    }
  },
  computed: {
    adapted_data() {
      let entry_table_id = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        entry_table_id = [parent_info_entity_type]
      }
      let adapted = {
        uid: this.brick_id,
        parents_info: entry_table_id,
        unicity_cols: this.unicity_cols,
        discriminating_cols: this.discriminating_cols,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
    generic_column_name_for_unicity_constructor() {
      return GenericColumnNameForUnicity
    },
  },

  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        // N.B PL : This may not be necessary
        new_val = new_val || {}
        this.table = (new_val.parents_info[0] || {}).uid || -1
      },
    },
    table: {
      immediate: true,
      async handler(new_val) {
        this.columns =
          (await table_columns(this.project_id, new_val)).pipe_object || []
        this.unicity_cols = _.cloneDeep(this.cur_brick.unicity_cols)
        this.discriminating_cols = _.cloneDeep(
          this.cur_brick.discriminating_cols
        )
      },
    },
  },
}
</script>
